/**
 * Rounds a price to the nearest tick increment.
 * Falls back to 2 decimal places if tickSize is absent or zero.
 */
export function roundToTick(price, tickSize) {
  if (!tickSize || tickSize <= 0) return Number(price).toFixed(2);
  const rounded = Math.round(price / tickSize) * tickSize;
  const decimals = Math.max(0, -Math.floor(Math.log10(tickSize)));
  return rounded.toFixed(decimals);
}

/**
 * Computes projected P&L if a position exits fully (or partially) at linePrice.
 *
 * For options the option price change is estimated via delta:
 *   optionPriceDelta ≈ delta × underlyingPriceDelta
 *
 * Returns null when data is insufficient.
 */
export function computePnlAtPrice({ linePrice, fillPrice, quantity, priceMultiplier, isLong, delta }) {
  if (linePrice == null || fillPrice == null || !quantity || !priceMultiplier) return null;

  let priceDelta;
  if (delta != null) {
    priceDelta = delta * (linePrice - fillPrice);
  } else {
    priceDelta = linePrice - fillPrice;
  }

  const directionFactor = isLong ? 1 : -1;
  return directionFactor * priceDelta * quantity * priceMultiplier;
}

/**
 * Formats a P&L dollar amount with sign and 2 decimal places.
 */
export function formatPnl(value) {
  if (value == null) return 'N/A';
  const sign = value >= 0 ? '+' : '-';
  return `${sign}$${Math.abs(value).toFixed(2)}`;
}
